import { generateMutations } from '../builder'

export default {
  ...generateMutations('getAiPrompts', 'aiPrompts'),
  ...generateMutations('getAiPrompt', 'aiPrompt'),
  ...generateMutations('getAiPrompt', 'aiPrompt'),
}
